import { type SelectionState } from './image-renderer.react';
type ActionData = {
  payload?: {
    x: number;
    y: number;
    refX?: number;
    refY?: number;
  };
  type: string;
};
export const reducer = (state: SelectionState, action: ActionData) => {
  switch (action.type) {
    case 'ON_MOUSE_DOWN':
      {
        if (!action.payload) {
          return state;
        }
        return {
          ...state,
          showSelection: true,
          selection: {
            ...state.selection,
            x: action.payload.x,
            y: action.payload.y,
            refX: action.payload.refX,
            refY: action.payload.refY
          }
        };
      }
    case 'ON_MOUSE_UP':
      {
        return {
          showSelection: false,
          enableSelection: false,
          selection: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          }
        };
      }
    case 'ON_MOUSE_MOVE':
      {
        if (!action.payload) {
          return state;
        }
        if (state.enableSelection && action.payload) {
          const payloadX = action.payload.x || 0;
          const payloadY = action.payload.y || 0;
          const selectionX = state.selection.x || 0;
          const selectionY = state.selection.y || 0;
          return {
            ...state,
            selection: {
              ...state.selection,
              width: payloadX - selectionX,
              height: payloadY - selectionY
            }
          };
        }
        return state;
      }
    case 'ON_OCR':
      {
        const selection = !state.enableSelection;
        return {
          ...state,
          enableSelection: selection
        };
      }
    default:
      {
        return state;
      }
  }
};